import { RESET_STATE } from 'store/global/actions';

import { LOAN_PROGRAM_OPTIONS_ACTION_TYPE } from '../actions';

const initialState = [];

const loanProgramOptionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_PROGRAM_OPTIONS_ACTION_TYPE.SET_LOAN_PROGRAM_OPTIONS:
      return Array.isArray(payload) ? payload : state;

    case LOAN_PROGRAM_OPTIONS_ACTION_TYPE.RESET_LOAN_PROGRAM_OPTIONS:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanProgramOptionsReducer;
